import { FETCH_START_CONTENT } from './constants'
import { take, call, put, select } from 'redux-saga/effects'
import { apiFetchStartContent } from './services'
import { fetchStartContent } from './actions'
import languages from '../../constants/languages'

function* fetchStartContentWorker(currentPhoneId) {
  const state = yield select()
  const preSaleFlag = state.devicebits.preSaleFlag
  const language = languages[state.devicebits.language]
  const customer = state.devicebits.customer
  const response = yield call(
    apiFetchStartContent,
    currentPhoneId,
    preSaleFlag,
    language,
    customer
  )

  if (Array.isArray(response)) {
    yield put(fetchStartContent.success(response, currentPhoneId))
  }
}

export default function* watcher() {
  while (true) {
    let payload = yield take(FETCH_START_CONTENT.REQUEST)
    yield call(fetchStartContentWorker, payload.currentPhoneId)
  }
}



// WEBPACK FOOTER //
// ./src/containers/GettingStarted/sagas.js